import { Formik } from 'formik';
import React from 'react';
import { Grid, Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import getErrors from 'shared/lib/geterrors';
import AvvisoService from 'shared/services/api/internokiron/avviso';
import _ from 'lodash';

import initialValues from './initialValues';
import Validation from './validation';
import DividerForm from '../../Forms/UI/DividerForm';
import { SaveBtn } from '../../Buttons';
import BaseForm from './baseForm';

export class EditorAvvisiModal extends React.Component {
  onSubmit = () => {
    this.baseForm.submitForm();
  };

  onBaseSubmit = (values, actions) => {
    actions.setSubmitting(true);

    if (!values.id || values.id.length === 0) {
      this.updateOrCreate('create', values, actions);
    } else {
      this.updateOrCreate('put', values, actions);
    }
  };

  updateOrCreate = (method, values, actions) => {
    const payload = {
      ...values,
      gravita: _.has(values, 'gravita.value') ? values.gravita.value : values.gravita,
    };

    // Servizio per aggiungere o aggiornare un messaggio
    AvvisoService[method](payload)
      .then((data) => {
        actions.setSubmitting(false);

        // Update parent with new data and resend to formik
        this.props.onEdit(data);

        // Success notification
        this.props.notifications.addNotification({
          message: 'Avviso salvato',
          level: 'success',
        });

        // Update parent list
        this.props.update();
        this.props.close();
      })
      .catch((errors) => {
        const errorsObj = getErrors(errors);
        actions.setSubmitting(false);
        actions.setErrors(errorsObj);

        // Error notification
        this.props.notifications.addNotification({
          message: _.get(errors, 'data.validation_messages.attivo')
            ? _.get(errors, 'data.validation_messages.attivo')
            : 'Si è verificato un problema con il salvataggio del form, ricontrolla i campi inseriti',
          level: 'error',
        });
      });
  };

  render() {
    return (
      <Grid>
        <Grid.Column width={16}>
          <Formik
            ref={(c) => {
              this.baseForm = c;
            }}
            initialValues={this.props.initialValues ? this.props.initialValues : initialValues}
            onSubmit={this.onBaseSubmit}
            validate={Validation}
            render={(props) => <BaseForm {...props} />}
          />
        </Grid.Column>
        <DividerForm />
        <Grid.Column width={8} textAlign="left">
          <Button onClick={this.props.close} type="button" icon="delete" labelPosition="right" content="Chiudi" />
        </Grid.Column>
        <Grid.Column width={8} textAlign="right">
          <SaveBtn action={this.onSubmit} />
        </Grid.Column>
      </Grid>
    );
  }
}

EditorAvvisiModal.propTypes = {
  initialValues: PropTypes.object,
  onEdit: PropTypes.func,
  notifications: PropTypes.object,
  update: PropTypes.func,
  close: PropTypes.func,
};

export default EditorAvvisiModal;



// WEBPACK FOOTER //
// ./app/components/EditorAvvisi/Form/index.js